import api from './api';

export const pollService = {
   getAll: (params) => api.get('/polls', { params }).then((r) => r.data),
   delete: (id) => api.delete(`/polls/${id}`).then((r) => r.data),
};
